import { render, staticRenderFns } from "./BuyerClaimDetails.vue?vue&type=template&id=fa78cfda&scoped=true"
import script from "./BuyerClaimDetails.vue?vue&type=script&lang=js"
export * from "./BuyerClaimDetails.vue?vue&type=script&lang=js"
import style0 from "./BuyerClaimDetails.vue?vue&type=style&index=0&id=fa78cfda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa78cfda",
  null
  
)

export default component.exports